import * as React from "react";
import { JSX } from "react/jsx-runtime";
const RedCrossIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 13L7.00002 7.00002L1 13ZM13 1L7.00002 7.00002L13 1ZM7.00002 7.00002L1 1L7.00002 7.00002ZM7.00002 7.00002L13 13L7.00002 7.00002Z"
      fill="#0F62FE"
    />
    <path
      d="M7.00002 7.00002L13 13M1 13L7.00002 7.00002L1 13ZM13 1L7.00002 7.00002L13 1ZM7.00002 7.00002L1 1L7.00002 7.00002Z"
      stroke="#F23030"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default RedCrossIcon;
